import { useAnonRestApi, useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import { ICitation, ICitationDoiDto, ICitationsApi } from '@vivli/shared/features/citations/infrastructure/interface';
import { IRorResponseItem } from '@vivli/features/organizations/infrastructure/interface';

export const useCitationsApi = (): ICitationsApi => {
    const { handleGet, handlePost, handlePut, handleDelete } = useAuthRestApi();

    const anonRestApi = useAnonRestApi();

    const getCitationFromDb = (id: string): Observable<ICitation> => {
        return anonRestApi.handleGet<ICitation>(`dois/${id}/citation`);
    };

    /*object id  is the document id of the data request or study that "owns" the citation*/
    const getCitationsForObject = (objectId: string, isStudy: boolean, doUpdate: boolean): Observable<ICitation[]> => {
        return handleGet<ICitation[]>(`dois/${objectId}/citation/${isStudy}/${doUpdate}`);
    };

    /*object id  is the document id of the data request or study that "owns" the citation*/
    const getCitationsForObjectAnonymous = (objectId: string, isStudy: boolean, doUpdate: boolean): Observable<ICitation[]> => {
        return anonRestApi.handleGet<ICitation[]>(`dois/${objectId}/citation/anon/${isStudy}/${doUpdate}`);
    };

    const createCitationFromDoi = (workDoi: string, dataRequestId: string, dataRequestDoiStem: string): Observable<ICitation> => {
        const workDoiDto: ICitationDoiDto = { citationDoi: workDoi };
        return handlePost<ICitation>(`/dois/providedDoi/${dataRequestId}/${dataRequestDoiStem}`, workDoiDto);
    };

    const createCitationFromObject = (citation: ICitation, dataRequestId: string, dataRequestDoiStem: string): Observable<ICitation> => {
        return handlePost<ICitation>(`/dois/providedCitation/${dataRequestId}/${dataRequestDoiStem}`, citation);
    };

    const updateCitation = (citation: ICitation, citationId: string, dataRequestDoiStem: string): Observable<ICitation> => {
        return handlePut<ICitation>(`dois/${citationId}/citation/${dataRequestDoiStem}`, citation);
    };

    const deleteCitation = (citationId: string, dataRequestId: string, dataRequestDoiStem: string): Observable<ICitation> => {
        return handleDelete<ICitation>(`dois/${citationId}/citation/${dataRequestId}/${dataRequestDoiStem}`);
    };

    const getRorMatches = (inputString: string): Observable<IRorResponseItem[]> => {
        return anonRestApi.handleGet<IRorResponseItem[]>(`dois/${inputString}/ror`);
    };

    return {
        getCitationFromDb,
        getCitationsForObject,
        getCitationsForObjectAnonymous,
        createCitationFromDoi,
        createCitationFromObject,
        updateCitation,
        deleteCitation,
        getRorMatches
    };
};
